import React from 'react'

export default function Contact() {
  return (
    <div>
      <div class="min-h-screen bg-[#111c3ef3] md:p-6 p-2">
        <h1 className='md:text-8xl text-4xl rounded-lg border-[#7FFFD4] text-center font-bold text-[#7FFFD4] box-border drop-shadow-md shadow-[#00FFFF] md:box-content '>CONTACTS👋</h1>
        <div className="flex flex-col justify-center mt-16 md:p-4  ">
          <h2 className='flex-start text-2xl font-bold text-[#F5DEB3]'>Nice to See you here, hope you would have loved the website and toggled through all the Tabs.Thanks for being an Amazing Visitor. Don't be a Visitor any more, Connect with me through Various Social platforms.</h2>
          <h2 className='mt-8 md:text-4xl text-2xl font-medium text-[#F5DEB3]'>Don't be a stranger just drop a mail !! <br/>😊 
          <a className="" href="mailto:ybawa108@gmail.com">Email</a></h2>
        </div>
      </div>
    </div>
  );
}
